import React from "react";
import Linktree from "../../shared/components/Linktree/Linktree";

import "./Home.css";

const Home = () => {
  // const matchResult = window.matchMedia("(max-width:575px)").matches;

  return <Linktree />;
};

export default Home;
